import React from 'react';

export default function VideoLogo() {
  return (
    <svg width="60" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="80" height="80" rx="16" fill="#4FA5A3" />
      <rect x="12.5" y="12" width="56" height="56" rx="28" fill="white" />
      <g clipPath="url(#clip0_878_3543)">
        <path
          d="M56.445 36.0562C56.441 35.3402 56.185 34.6992 55.722 34.1752C55.374 33.7832 54.789 33.4472 54.16 33.4382C53.951 33.4342 53.735 33.4652 53.522 33.5432C51.999 34.1012 50.463 34.6592 48.949 35.2242V33.7742C48.949 32.0202 47.506 30.5762 45.752 30.5762H27.699C25.944 30.5752 24.5 32.0202 24.5 33.7732V46.2202C24.5 47.9742 25.943 49.4242 27.698 49.4242H45.752C47.506 49.4242 48.949 47.9742 48.949 46.2202V44.7802C50.494 45.2672 52.072 45.7292 53.632 46.1992C54.437 46.3812 54.982 46.4432 55.547 46.1452C55.943 45.9362 56.206 45.4702 56.333 45.0572C56.461 44.6452 56.503 44.2032 56.498 43.6562L56.445 36.0562ZM46.816 46.2212C46.816 46.8302 46.363 47.2922 45.753 47.2922H27.7C27.092 47.2922 26.636 46.8312 26.636 46.2212V33.7732C26.636 33.1642 27.092 32.7102 27.7 32.7102H45.754C46.362 32.7102 46.817 33.1632 46.817 33.7732L46.816 46.2212ZM54.25 44.1582L49.685 42.7792C49.207 42.6502 48.976 42.4542 48.953 42.2742V37.7152C49.009 37.4362 49.497 37.3222 49.74 37.2032L54.126 35.5912C54.311 35.5442 54.32 35.9382 54.315 36.0702L54.369 43.6702C54.373 43.9342 54.344 44.1702 54.25 44.1582Z"
          fill="#4FA5A3"
        />
      </g>
      <defs>
        <clipPath id="clip0_878_3543">
          <rect width="32" height="32" fill="white" transform="translate(24.5 24)" />
        </clipPath>
      </defs>
    </svg>
  );
}
